import Icon from "@mdi/react";
import { mdiStar } from "@mdi/js";

// tools
import { Priority } from "tools/Enums";

// components
import { dropDownOptions } from "components/DropDownMenu";

const star = <Icon key={0} path={mdiStar} size={0.9} color="grey" />;
const starTwo = (
	<>
		<Icon key={1} path={mdiStar} size={0.9} color="grey" />
		<Icon key={2} path={mdiStar} size={0.9} color="grey" />
	</>
);
const starThree = (
	<>
		<Icon key={3} path={mdiStar} size={0.9} color="grey" />
		<Icon key={4} path={mdiStar} size={0.9} color="grey" />
		<Icon key={5} path={mdiStar} size={0.9} color="grey" />
	</>
);

export default class GetPriority {
	static getName(priority) {
		switch (priority) {
			case Priority.Low:
				return "Low";
			case Priority.Medium:
				return "Medium";
			case Priority.High:
				return "High";
		}
	}
	static getDropDownItem(priority) {
		switch (priority) {
			case Priority.Low:
				return new dropDownOptions(star, " Low", "", 0);
			case Priority.Medium:
				return new dropDownOptions(starTwo, " Medium", "", 1);
			case Priority.High:
				return new dropDownOptions(starThree, " High", "", 2);
		}
	}
	static getIcon(priority) {
		switch (priority) {
			case Priority.Low:
				return star;
			case Priority.Medium:
				return starTwo;
			case Priority.High:
				return starThree;
		}
	}
}
export const dropDownPriorityOptionsArray = [
	GetPriority.getDropDownItem(Priority.Low),
	GetPriority.getDropDownItem(Priority.Medium),
	GetPriority.getDropDownItem(Priority.High),
];
